import { useSettings } from "../../../api/Settings";
import { Form } from "antd";
import SingleFieldForm from "../../../components/SingleFieldForm";

const defaultSettings = [
  {
    SettingName: "MonthlyBudget",
    SettingValue: 0,
  },
  {
    SettingName: "EmailDomain",
    SettingValue: null,
  },
];

const OrganizationLimits = ({ organizationId }) => {
  const data = useSettings("Organization", organizationId);

  //TODO: Save the value to the API
  const saveLimit = (value) => {
    console.log(value);
    return Promise.resolve();
  };

  return (
    <Form layout="vertical" initialValues={defaultSettings}>
      <SingleFieldForm
        onSubmit={saveLimit}
        name="MonthlyBudget"
        label="Monthly Budget"
      />
    </Form>
  );
};

export default OrganizationLimits;
